import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    View,
    ScrollView,
    TouchableOpacity,
    FlatList,
    Dimensions,
    Platform
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDImage,
    JDLogin,
    JDScrollView,
    JDConfirmDialog
} from '@jdreact/jdreact-core-lib';
import { utils } from '@ltfe/ltfe-core-lib';

import MovieInfo from '../components/movieSchedule/movie-info';
import SeeTomorrow from '../components/movieSchedule/see-tomorrow';
import Loading from '../components/common/loading';
import Menu from '../components/menu';
import WifiOut from '../components/common/wifi-out';
import Tag from '../components/common/tag';
import LoadingAnimation from '../components/index/loading-animation';

import { get } from '../common/fetch';
import { tip, mta, mtaPV, getByteLen, clip, is_web } from '../common/utils';
import CityScreening from '../components/common/cityScreening';
import DownLayer from '../components/common/cityScreening/downLayer';
import ScrollTopButton from '../components/index/scroll-top-button';
import BookShowItem from '../components/movieSchedule/book-show-item';

import img from '../common/img';
import st from '../style/movie.schedule.st';
import sgmReport from '../common/sgmUtil';

const { getLBS, pt, iphoneXMarginBottom, store, sceneId, LBSbusinessId } = utils;


let flatlistMinHeight = pt(Dimensions.get('window').height - 75);
if (Platform.OS === 'ios') {
    // flatlistMinHeight -=  (44 + iphoneXMarginBottom);
    flatlistMinHeight = pt(Dimensions.get('window').height - 75 - 44 - iphoneXMarginBottom)

}

/**
 * 影院列表页
 */
class MovieSchedule extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            wifiOut: false,
            movieId: props.movieId,
            scheduledType: props.scheduledType,
            // movieId: 76150,
            movieInfo: {},
            dateList: [],
            curDateIndex: 0,
            theDate: '',
            cinemaList: [],
            allowScroll: true,
            totalNum: 0,
            pageNum: 1,
            pageSize: 20,
            queryDate: '',
            shareInfo: {},
            regionList: [],
            currentCity: '',
            formattedAd: '',
            positionSuccess: false,
            toTopIsShow: false,
            isPosition: false,

            // 筛选
            theRegionId: 0,
            theBrandId: 0,
            theDistanceId: 0,
            theDiscountId: '0',
            // regionList: [],
            brandList: [],
            distanceList: [
                {
                    distanceName: '由近到远',
                    distanceId: 1
                },
                {
                    distanceName: '由远到近',
                    distanceId: 2
                }
            ],
            discountList: [
                {
                    discountName: '筛选',
                    discountId: '0'
                },
                {
                    discountName: '政府补贴优惠',
                    discountId: '1'
                },
                {
                    discountName: '满减',
                    discountId: '2'
                },
                {
                    discountName: '一口价',
                    discountId: '3'
                }
            ],
            currentSearchType: null,
            currentRegion: {
                regionName: '全城',
                regionId: 0
            }, // 当前区域
            currentBrand: {
                brandName: '品牌',
                brandId: 0
            }, // 当前品牌
            currentDistance: {
                distanceName: '由近到远',
                distanceId: 1
            },
            currentDiscount: {
                discountName: '筛选',
                discountId: '0'
            },
            // 定位失败提示
            dialog: false,
            // 切换城市提示
            // lbsDialog: false,
            isShowLayer: false,
            searchLoading: false,
            navBarHeight: 0,
            selectBarHeight: 0,
            govSubsidy: false,
            govSubsidyText: '',// 哈尔滨政府补贴筛选项文案，不同时间段不同
            govSubsidyTag: '', // 哈尔滨政府补贴筛选项Tag，不同时间段不同
        };
        this.getAllInfo = this.getAllInfo.bind(this);
        this.getMovieIssueShowDate = this.getMovieIssueShowDate.bind(this);
        this.getShowingCinemaList = this.getShowingCinemaList.bind(this);
        this.getMovieInfo = this.getMovieInfo.bind(this);

         this.goCity = this.goCity.bind(this);
        // this.closeDialog = this.closeDialog.bind(this);
        this.closeFalseDialog = this.closeFalseDialog.bind(this);
        // this.setCity = this.setCity.bind(this);

        this.refresh = this.refresh.bind(this);
        this.setShare = this.setShare.bind(this);
        this.render_item = this.render_item.bind(this);
        this._goTop = this._goTop.bind(this);
        this.pageLoading = false;
    }

    render() {
        const { 
            loading, 
            wifiOut,
            movieId,
            movieInfo,
            pageNum,
            totalNum,
            allowScroll,
            dateList,
            curDateIndex,
            cinemaList,
            shareInfo,
            formattedAd,
            currentCity,
            positionSuccess,
            isPosition,
            toTopIsShow,
            dialog,
            // lbsDialog, 
         } = this.state;
        //  添加一个scheduledType=== 'bookShow'表示 预约放映点击拼场购票进来的，展示的list item 不一样，其他的都一样
        const { cur_city, lbsCity, scheduledType } = this.props;

        const {
            currentRegion,
            currentBrand,
            currentDistance,
            currentSearchType,
            isShowLayer,
            regionList,
            brandList,
            distanceList,
            discountList,
            currentDiscount,
            govSubsidy,
            govSubsidyText,
            govSubsidyTag,
        } = this.state;

        return (
            <View style={ st.container }>

                {!wifiOut &&
                    <JDScrollView
                        showsVerticalScrollIndicator={ false }
                        scrollEnabled={ true }
                        stickyHeaderIndices={ [0] }
                        onScroll={ (e) => this._onScroll(e) }
                        ref={ (scroll) => { this._scroll = scroll; } }
                        style={ st.wrap }
                    >
                        <View>
                            {/* 顶部信息栏 */}
                            <MovieInfo
                                movieInfo={ movieInfo }
                                scheduledPlay={+scheduledType === 3 ? 1 : 0} // 拼团电影需求添加
                            />
                            {/* 筛选栏 */}
                            {!!dateList.length &&
                                <View style={ st.selected } ref="selectBar">
                                    {/* 日期筛选 */}
                                    <View style={ st.date_selected }>
                                        <FlatList
                                            showsHorizontalScrollIndicator={ false }
                                            horizontal={ true }
                                            data={ dateList }
                                            ref={ (scroll) => { this._dateScroll = scroll; } }
                                            keyExtractor={ (item, index) => index + '' }
                                            extraData={ this.state }
                                            initialNumToRender={ dateList.length }
                                            renderItem={ ({ item, index }) =>
                                                <JDTouchable
                                                    style={ st.date_item_wrap }
                                                    onPress={ () => this.selectedDate(item, index) }
                                                >
                                                    <View style={ [st.date_wrap, !!(index == curDateIndex) && st.cur_data_wrap] }>
                                                        <JDText style={ [st.date_selected_item, !!(index == curDateIndex) && st.cur_data_item] }>{item.split(',')[0]}</JDText>
                                                    </View>
                                                </JDTouchable>
                                            }
                                        />
                                    </View>
                                    {/* 城市筛选
                                    {<CityScreening
                                        indexFlag={ false }
                                        scrollToCity={ this.scrollToCity }
                                        currentRegion={ currentRegion }
                                        currentBrand={ currentBrand }
                                        currentDistance={ currentDistance }
                                        currentDiscount={ currentDiscount }
                                        govSubsidy={ govSubsidy }
                                        currentSearchType={ currentSearchType } />}
                                </View> */}
                                {/* 城市筛选 */}
                                {<CityScreening
                                    indexFlag={ false }
                                    scheduledType={ scheduledType }
                                    scrollToCity={ this.scrollToCity }
                                    currentRegion={ currentRegion }
                                    currentBrand={ currentBrand }
                                    currentDistance={ currentDistance }
                                    currentDiscount={ currentDiscount }
                                    govSubsidy={ govSubsidy }
                                    currentSearchType={ currentSearchType } />
                                }
                            </View>}
                        </View>
                        {/* 影院列表 */}
                        {!loading &&
                            <View style={ { minHeight: flatlistMinHeight } }>
                                <FlatList
                                    data={ cinemaList }
                                    keyExtractor={ (item) => item.cinemaId + '' }
                                    initialNumToRender={ 10 }
                                    renderItem={ this.render_item }
                                    ListEmptyComponent={ () => <SeeTomorrow contentText="当日暂无可售场次" /> }
                                />
                            </View>
                        }
                        {loading &&
                            <Loading contentStyle={ { marginTop: pt(230), marginBottom: pt(Dimensions.get('window').height - 305) } } />
                        }
                        {!loading && pageNum <= totalNum &&
                            <LoadingAnimation />
                        }
                        {pageNum > totalNum && !loading && cinemaList.length > 20 &&
                            <View style={ { alignItems: 'center', justifyContent: 'center', marginVertical: pt(10) } }>
                                <JDText>我是有底线的(^_^)</JDText>
                            </View>
                        }
                        {/* 定位失败提示 */}
                        <JDConfirmDialog
                            show={ dialog }
                            onConfirm={ this.goCity }
                            onClose={ this.closeFalseDialog }
                            confirmText="选择城市"
                            cancelText="取消"
                        >
                            <View style={ st.dialog }><JDText style={ st.dialog_txt }>定位失败，可能是您的手机关闭了定位权限。您可以去手机设置-隐私-打开定位，或者手动选择城市。</JDText></View>
                        </JDConfirmDialog>

                        {/* 切换为定位城市提示 */}
                        {/* {!!lbsCity && <JDConfirmDialog
                            show={ lbsDialog }
                            onConfirm={ this.setCity }
                            onClose={ this.closeDialog }
                            confirmText="切换"
                            cancelText="取消"
                        >
                            <View style={ [st.dialog, { paddingBottom: pt(10) }] }>
                                <JDText style={ st.dialog_txt }>发现您正在{lbsCity.cityName}</JDText>
                            </View>
                            <View style={ { marginBottom: pt(20) } }>
                                <JDText style={ [st.dialog_txt, st.gray] }>是否切换?</JDText>
                            </View>
                        </JDConfirmDialog>} */}
                    </JDScrollView>
                }
                {
                    isShowLayer &&
                    <View style={ { position: 'absolute',top: pt(70 + 57), elevation: 999999, zIndex: 999999, width: '100%' } }>
                        <DownLayer
                            indexFlag={ false }
                            isShowResult={ isShowLayer }
                            regionList={ regionList }
                            brandList={ brandList }
                            distanceList={ distanceList }
                            discountList={ discountList }
                            govSubsidyText={ govSubsidyText }
                            govSubsidyTag={ govSubsidyTag }
                            searchCinema={ this.selectedSearchItem }
                            closeLayer={ () => { this.setState({ isShowLayer: false, currentSearchType: null, allowScroll: true }); } }
                            currentRegion={ currentRegion }
                            currentBrand={ currentBrand }
                            currentDistance={ currentDistance }
                            currentDiscount={ currentDiscount }
                            currentSearchType={ currentSearchType } />
                    </View>
                }

                {wifiOut &&
                    <WifiOut
                        refresh={ dateList.length > 0 ? this.refresh : this.toIndex }
                        middleText={ dateList.length > 0 ? '' : '该城市暂无此影片排期' }
                        buttonText={ dateList.length > 0 ? '' : '去首页看看' }
                        contentStyle={ { flex: 1 } }
                    />
                }
                {/* {!loading && !wifiOut &&
                    <TouchableOpacity
                        style={ [st.position_wrap, { marginBottom: iphoneXMarginBottom }] }
                        activeOpacity={ 0.5 }
                        onPress={ () => this.getPosition() }
                    >
                        <JDTouchable
                            style={ st.reload }
                            onPress={ this.getPosition }
                        >
                            <JDImage style={ st.reload_img } source={ img.reload } />
                        </JDTouchable>
                        {isPosition &&
                            <JDText style={ st.now_city }>正在定位...</JDText>
                        }
                        {positionSuccess && !isPosition &&
                            <View style={ st.position_city }>
                                // <JDText style={st.now_city}>您在 { currentCity }市</JDText>
                                <JDText numberOfLines={ 1 } style={ [st.now_city, currentCity != cur_city.cityName && st.now_dif_city] }><JDText style={ st.loaction_txt }>您在 </JDText>{formattedAd}</JDText>
                                {currentCity != cur_city.cityName &&
                                    <JDText style={ st.text_style }>点击</JDText>
                                }
                                {currentCity != cur_city.cityName &&
                                    <JDTouchable style={ st.check_city } onPress={ () => this.checkoutCity() }>
                                        <JDText style={ st.switch_city }>切换城市</JDText>
                                    </JDTouchable>
                                }
                            </View>
                        }
                        {!positionSuccess && !isPosition &&
                            <View style={ st.position_city }>
                                <JDText style={ st.now_city }>定位失败，请确定是否已开启定位服务</JDText>
                            </View>
                        }
                    </TouchableOpacity>
                } */}
                {/* 开场提示 */}
                {/* <OpeningHint ref={(hint) => this._hint = hint} /> */}
                {toTopIsShow &&
                    <ScrollTopButton goTop={ this._goTop } />
                }
                <Menu from='movieSchedule' shareInfo={ shareInfo } ref={ e => { this.refMenu = e; } } />
            </View>
        );
    }

    componentDidMount() {
        const { movieInfo, scheduledType } = this.state;
        let title = '选择影院'
        if(movieInfo?.movieName) {
            title = getByteLen(movieInfo.movieName) > 20 ? clip(movieInfo.movieName, 20) + '...' : movieInfo.movieName;
        }
        this.setTitle(title);
        // this.getMovieIssueShowDate();
        // this.getPosition();
        // this.initCity();
        if (is_web) {
            const selectedSeat = store.getItem('selectedSeat');
            const planId = store.getItem('planId');
            if (selectedSeat != null) {
                get('releaseSeat', {
                    planId,
                    selectedSeat,
                    scheduledPlay: +scheduledType === 3 ? 1 : 0
                }).then((res) => { });

                if(!planId || !selectedSeat){
                    sgmReport('1001', {function_id: 'releaseSeat',message:'缺少参数planId/selectedSeat'}, 3)
                }
            };
            localStorage.removeItem('selectedSeat');
        }
        const { movieId } = this.state;
        // const { scheduledType }=this.props;
        const { cityId, cityPy, cityName, fullCityPy, from } = this.props;

        if (from && from == "h5") {//说明是h5跳转过来的，不需要再重新走获取城市信息接口数据，只需要把带过来的城市信息参数重置给store:cur_city
            this.props.dispatch({
                type: "cur_city",
                cur_city: { cityId, cityPy, cityName, fullCityPy },
            });

            setTimeout(() => {
                this.getAllInfo({ cityId, cityPy, cityName, fullCityPy })
            }, 100);
        }else {
            if(+scheduledType===3){
                this.setState({ wifiOut: false, loading: true ,cinemaList: []},()=>{
                    this.initCity();
                });
            }else{
                this.getAllInfo()
            }
        }

        mtaPV('List', `${movieId}`);
    // }
    // componentDidMount() {
        // this.getMovieInfo();
        // this.getMovieIssueShowDate();
        // this.getPosition();
        // 开场提示
        // this._hint.hintStorage();
    }
   
    getAllInfo(cur_city_my) {
        const {scheduledType}=this.props;
        if(cur_city_my&&cur_city_my.cityName&&+scheduledType===3){
            this.setState({
                currentRegion: {
                    ...this.state.currentRegion,
                    regionName: cur_city_my.cityName
                }
            })
        }
        this.getMovieInfo(cur_city_my);
        this.getMovieIssueShowDate(cur_city_my);
    }

    componentDidFocus() {
        const { cur_city } = this.props;
        console.log('cur_city---------',cur_city)
        const that=this
        if (this.canLoad) {
            storage.load({
                key: 'movieCityHistory'
            }).then(hisres => {
                if(hisres && hisres.length > 0){
                    dispatch({
                        type: 'cur_city',
                        cur_city: hisres[0]
                    });
                    that.setState({cinemaList: []},()=>{
                        that.getAllInfo(hisres[0]);
                    })
                }else if(cur_city){
                    that.setState({cinemaList: []},()=>{
                        that.getAllInfo(cur_city);
                    })
                }
            }).catch((e)=>{
                console.log(e)
                if(cur_city){
                    that.setState({cinemaList: []},()=>{
                        that.getAllInfo(cur_city);
                    })
                }
            })
        }
    }
    componentWillUnfocus() {
        const { scheduledType }=this.props;
        if(+scheduledType===3){
            this.canLoad = true;
        }
    }

    // initCity = () => {
    //     // 与历史城市对比
    //     storage.load({
    //         key: 'movieCityHistory'
    //     }).then(hisres => {
    //         if (hisres) {
    //             // 有历史记录
    //             this.props.dispatch({
    //                 type: 'cur_city',
    //                 cur_city: hisres[0]
    //             });
    //             this.getMovieInfo(hisres[0].cityId);
    //             this.getMovieIssueShowDate(hisres[0].cityId);
    //         }
    //     }).catch((err) => {
    //         this.getMovieInfo();
    //         this.getMovieIssueShowDate();
    //     });
    // }

    // 获取排期
    getMovieIssueShowDate(cur_city_my) {
        const { cur_city, scheduledType } = this.props;
        get('getMovieIssueShowDate', {
            cityId: cur_city_my?cur_city_my.cityId:cur_city.cityId,
            movieId: this.state.movieId,
            scheduledPlay: +scheduledType === 3 ? 1 : 0 // 拼团电影需求添加
        }, true).then((res) => {
            const dateList = res.data.showTimes;
            
            if (!dateList.length) {
                this.setState({ wifiOut: true,dateList:[] });
                return;
            }

            const theDate = dateList[0].split(',')[1];

            this.getShowingCinemaList(theDate);

            this.setState({ dateList, theDate }, () => {
                this.filterCinemas();
            });
        }, () => {
            this.setState({ wifiOut: true });
        }).catch(() => {
            this.setState({ wifiOut: true });
        });

        if((!cur_city_my && cur_city.cityId) || !this.state.movieId){
            sgmReport('1001', {function_id: 'getMovieIssueShowDate',message:'缺少参数cityId/movieId'}, 3)
        }
    }

    getMovieInfo(cur_city_my) {
        const { movieId } = this.state;

        const { cur_city } = this.props;

        get('getMovieInfoVO', { movieId, cityId: cur_city_my?cur_city_my.cityId:cur_city.cityId }).then((res) => {
            const movieInfo = res.data || {};

            this.setState({ movieInfo });
            this.setShare(movieInfo);
        });

        if((!cur_city_my && !cur_city?.cityId) || !movieId){
            sgmReport('1001', {function_id: 'getMovieInfoVO',message:'缺少参数cityId/movieId'}, 3)
        }
    }

    // 获取影院列表
    getShowingCinemaList(date, pageNum = 1, pageSize = 20, queryDate = '') {
        const { scheduledType } = this.state;
        const { cur_city, lbs } = this.props;

        const {
            movieId, theRegionId, theBrandId,
            theDistanceId, shareInfo, theDiscountId
        } = this.state;

        const params = {
            cityId: cur_city.cityId,
            regionId: theRegionId,
            brandId: theBrandId,
            descDistance: theDistanceId !== 2,
            promoFilter: [theDiscountId],
            movieId: movieId,
            showDate: date,
            pageNum,
            pageSize,
            queryDate
        };
        try{
            lbs = store.getItem('lbs');
        }catch(e){

        }
        params.lon = lbs?.lon || 0;
        params.lat = lbs?.lat || 0;
        const functionId = +scheduledType === 3 ? 'scheduledCinemaAndPlanList' : 'showingCinemaList';
        get(functionId, params, true).then((res) => {
            if (!res.data || res.data.list.length === 0) {
                this.setState({ cinemaList: [], loading: false, searchLoading: false });

                return;
            }
            let cinemaList = res.data.list;

            const queryDate = res.data.queryDate;

            const totalNum = Math.ceil(res.data.totalCount / 20);

            pageNum += 1;
            const cinemaListCopy = this.state.cinemaList;

            cinemaList = cinemaListCopy.concat(cinemaList);

            shareInfo.msg = +scheduledType === 3? `${cur_city.cityName}${res.data.totalCount}家可预约放映，最低2人可拼场，立即查看！`: `${cur_city.cityName}${res.data.totalCount}家影院正在热映，立即查看！`;

            window.jdShare?.setShareInfo({
                title: `电影【${this.state.movieInfo.movieName}】京东购票更优惠`,
                content: `${cur_city.cityName}${res.data.totalCount}家影院正在热映，立即查看！`,
                url: window.location.href,
                img: 'https://storage.jd.com/ltmovie/movieLogo.jpg',
                channel: '',
                callback: null
            });

            this.setState({ cinemaList, pageNum, queryDate, totalNum, loading: false, searchLoading: false, shareInfo });

            if(cinemaList && cinemaList.length && +scheduledType === 3){
                const hasEmpty = cinemaList.some(item => !item.jdPicUrl);
                if(hasEmpty){
                    sgmReport('1002', {function_id: functionId, message:'数据未返回图片地址！'}, 3)
                }
            }

            setTimeout(() => {
                this.pageLoading = false;
            }, 1000);
        }, () => {
            this.setState({ wifiOut: true });
        }).catch(() => {
            this.setState({ wifiOut: true });
        });

        if(!cur_city.cityId || !theRegionId || !theBrandId || !movieId){
            sgmReport('1001', {function_id: functionId,message:'缺少参数cityId/regionId/brandId/movieId'}, 3)
        }
    }

    selectedDate(item, curDateIndex) {
        const { loading, dateList, scheduledType } = this.state;

        const curIndex = this.state.curDateIndex;

        const length = dateList.length;

        if (!loading && !this.pageLoading && curIndex !== curDateIndex) {
            if (+scheduledType !== 3) { // 非预约放映走老逻辑
                this._scroll.scrollTo({ x: 0, y: 0, animated: false });
            }

            if (length > 4) {
                //  最后两项通过scrollToEnd滚动
                if (curDateIndex + 2 > length - 1) {
                    this._dateScroll.scrollToEnd({ animated: true });
                } else {
                    this._dateScroll.scrollToIndex({ animated: true, index: curDateIndex, viewPosition: 0.5 });
                }
            }

            this.setState({
                loading: true,
                searchLoading: true,
                pageNum: 1,
                totalNum: 0,
                cinemaList: [],
                curDateIndex,
                theDate: item.split(',')[1],
                currentSearchType: null,
                isShowLayer: false,
                allowScroll: true
            }, () => {
                this.filterCinemas(filterDdata => {
                    this.getShowingCinemaList(item.split(',')[1]);
                });
            });

            mta('MoCiDateTab', 'List', `${item.split(',')[1]}`);
        }
    }

    // 获取区域和品牌数量
    filterCinemas = (callback) => {
        const { scheduledType } = this.state;
        const cityId = this.props.cur_city.cityId;
        const indexFlag = false;
        const showDate = this.state.theDate;
        const movieId = this.state.movieId;

        get('filterCinemas', {
            cityId,
            indexFlag,
            showDate,
            movieId,
            scheduledPlay: +scheduledType === 3 ? 1 : 0
        }).then(res => {
            this.setState({
                regionList: res.data.region,
                brandList: res.data.brand,
                govSubsidy: res.data.govSubsidy === 'true',
                govSubsidyText: res.data.govSubsidyText,
                govSubsidyTag: res.data.govSubsidyTag
            }, () => {
                callback && callback(res.data);
            });
        });

        if(!this.props.cur_city.cityId || !this.state.movieId){
            sgmReport('1001', {function_id: 'filterCinemas',message:'缺少参数cityId/movieId'}, 3)
        }
    }

    // 选择区域
    selectedSearchItem = (item) => {
        
        const { cur_city } = this.props;
        const { currentSearchType, currentRegion } = this.state;

        if (currentSearchType === 'region') {
            mta('MoCiAreaItem', 'List', `${cur_city.cityName}_${item.regionName}_${item.cinemaCount}`);
        } else if (currentSearchType === 'brand') {
            mta('MoCiBrandItem', 'List', `${cur_city.cityName}_${currentRegion.regionName}_${item.brandName}_${item.cinemaCount}`);
        } else if (currentSearchType === 'distance') {
            mta('MoCiDistanItem', 'List', `${item.distanceName}`);
        } else if (currentSearchType === 'discount') {//筛选
        }

        this.setState({ loading: true, cinemaList: [] });
        const { loading, theDate } = this.state;

        if (!loading && !this.pageLoading) {
            this._scroll.scrollTo({ x: 0, y: 0, animated: false });
            if (currentSearchType === 'region') {
                this.setState({ loading: true, theRegionId: item.regionId, currentRegion: item }, () => {
                    this.getShowingCinemaList(theDate);
                });
            } else if (currentSearchType === 'brand') {
                this.setState({ loading: true, theBrandId: item.brandId, currentBrand: item }, () => {
                    this.getShowingCinemaList(theDate);
                });
            } else if (currentSearchType === 'distance') {
                this.setState({ loading: true, theDistanceId: item.distanceId, currentDistance: item }, () => {
                    this.getShowingCinemaList(theDate);
                });
            } else if (currentSearchType === 'discount') {//筛选条件
                this.setState({ loading: true, theDiscountId: item.discountId, currentDiscount: item }, () => {
                    this.getShowingCinemaList(theDate);
                });
            }
        }
    }

    scrollToCity = type => {
        const { cur_city, scheduledType } = this.props;
        const event_id = type === 'region' ? 'MoCiFilterArea' : (type === 'brand' ? 'MoCiFilterBrand' : 'MoCiFilterDistan');
        mta(event_id, 'List', `${cur_city.cityName}`);
        
        // 预约放映时点击城市名称跳转至选择城市页
        if(event_id==='MoCiFilterArea'&&+scheduledType===3){
            this.setState({
                currentSearchType: null,
                isShowLayer: false,
                // allowScroll: true
            })
            this.context.router.toCity();
            return 
        }
        

        const _currentSearchType = this.state.currentSearchType;

        this._scroll.scrollTo({ x: 0, y: pt(60), animated: false });
        if (_currentSearchType === type) {
            this.setState({
                currentSearchType: type,
                isShowLayer: !this.state.isShowLayer
            }, () => {
                if (!this.state.isShowLayer) {
                    this.setState({
                        currentSearchType: null,
                        allowScroll: true
                    });
                } else {
                    this.setState({
                        allowScroll: false
                    });
                }
            });
        } else {
            this.setState({
                currentSearchType: type,
                isShowLayer: true
            }, () => {
                this.setState({
                    allowScroll: false
                });
            });
        }
    }

    toMovieList(item) {
        const { cinemaId, showDate: theDate } = item;
        const { movieId, movieInfo } = this.state;

        this.context.router.toMovieList({ cinemaId, movieId, theDate, skuId: movieInfo.jSkuId });
    }

    goBuy = (item, offtenItem) => {
        const { movieId, movieInfo, scheduledType } = this.state;
        mta('MoCiTime', 'List', `${item.cinemaId}_${item.showDate} ${offtenItem.showTime}_${offtenItem.price || offtenItem.jdPrice}`);
        const seat = {
            planId: offtenItem.planId, // 场次id
            movieId, // 影片id
            title: item.cinemaName, // 影院名称
            movieName: movieInfo.movieName, // 影片名称
            theDate: item.showDate, // 选择日期 [2018-8-27]
            startTime: offtenItem.showTime, // 影片开始时间 [13:00]
            playType: offtenItem.playType, // 影片信息（3d/2d)
            hallName: offtenItem.hallName, // 影厅信息（几号厅)
            promtId: offtenItem.promtId, //  促销id
            scheduledPlay: +scheduledType === 3 ? 1 : 0
        };

        JDLogin.isLogin().then(() => {
            jump();
        }, () => {
            JDLogin.doLogin().then(() => {
                jump();
            });
        }).catch(() => jump());
        console.log(item, offtenItem);

        const jump = () => {

            this.context.router.toSeat(seat);
        };
    }

    setShare(movieInfo) {
        const { cur_city } = this.props;

        const { cinemaList, scheduledType } = this.state;

        window.jdShare?.setShareInfo({
            title:+scheduledType === 3 ? `电影${movieInfo.movieName}，上京东预约放映，精彩重现~`:  `电影【${movieInfo.movieName}】京东购票更优惠`,
            content:+scheduledType === 3? `${cur_city.cityName}${cinemaList.length}家可预约放映，最低2人可拼场，立即查看！`:  `${cur_city.cityName}${cinemaList.length}家影院正在热映，立即查看！`,
            url: window.location.href,
            img: 'https://storage.jd.com/ltmovie/movieLogo.jpg',
            channel: '',
            callback: null
        });
        const shareInfo = {
            url: `https://m-movie.jd.com/va/movieNew/${cur_city.cityId}/${movieInfo.movieId}?jdreactkey=JDReactMovie&jdreactapp=JDReactMovie&rn_transparentenable=true&rn_routerName=MovieSchedule&rn_movieId=${movieInfo.movieId}&rn_cityId=${cur_city.cityId}`,
            title:+scheduledType === 3?`电影${movieInfo.movieName}，上京东预约放映，精彩重现~` : `电影【${movieInfo.movieName}】京东购票更优惠`,
            msg:+scheduledType === 3? `${cur_city.cityName}${cinemaList.length}家可预约放映，最低2人可拼场，立即查看！`: `${cur_city.cityName}${cinemaList.length}家影院正在热映，立即查看！`
            // logo: movieInfo.jdPicUrl
        };

        this.setState({
            shareInfo
        });
    }

    goSearch = () => {
        const { movieId, movieInfo } = this.state;

        this.context.router.toMovieCinemaSearch({ movieId, skuId: movieInfo.jSkuId });
    }

    render_item({ item, index }) {
        const { scheduledType } = this.state;

        if (+scheduledType === 3) {
            return (
                <BookShowItem data={ item } goBuy={ this.goBuy } />
            );
        }
        return (
            <TouchableOpacity
                key={ index }
                activeOpacity={ 0.5 }
                style={ st.cinema_item }
                onPress={ () => {
                    mta('MoCiInfo', 'List', `${item.cinemaId}_${item.isFreqCinema === 1 ? '是' : '否'}_${index + 1}`);
                    this.toMovieList(item);
                } }
            >
                <View style={ [st.cinema_name_wrap, st.cinema_common] }>
                    <JDText numberOfLines={ 1 } style={ st.cinema_name }>{item.cinemaName}</JDText>
                    {!!item.planPrice &&
                        <JDText style={ st.cinema_price_wrap }>
                            <JDText style={ st.cinema_price }>&yen;{item.planPrice / 100}</JDText>起
                        </JDText>
                    }
                </View>
                <View style={ [st.cinema_address_wrap, st.cinema_common] }>
                    <JDText numberOfLines={ 1 } style={ st.cinema_address }>{item.address}</JDText>
                    {!!item.cinemaDistance && <JDText style={ st.cinema_km }>{item.cinemaDistanceStr}</JDText>}
                </View>
                <Tag cinemaTag={ item.cinemaTag } key={ 4 } />
                {
                    item.activityType >= 0 && !!item.promoPrice && item.govSubsidy !== "true" &&
                    <View style={ st.v_tip }>
                        <View style={ st.tip }>
                            <JDText style={ st.scale }>惠</JDText>
                        </View>
                        <JDText style={ st.i_text }>{item.promoDesc}</JDText>
                    </View>
                }
                {
                    item.activityType >= 0 && !!item.promoPrice && item.govSubsidy === "true" && 
                    <View style={ st.governmentSubsidyContainer }>
                        <JDText style={ st.governmentSubsidyDiscounts }>惠</JDText>
                        <JDText style={ st.governmentSubsidyContent }>{item.promoDesc}</JDText>
                        {/* <JDText style={ st.governmentSubsidyContent }>{`政府补贴·活动立减6元`}</JDText> */}
                    </View>
                }
                {(item.isFreqCinema == 0) &&
                    <View style={ st.show_time_out }>
                        {item.showTime
                            ? <JDText style={ st.show_time_wrap }>
                                最近场次：
                                {item.nextState == 1 &&
                                    <JDText>(次日)</JDText>
                                }
                                <JDText style={ st.show_time }>{item.showTime}</JDText>
                            </JDText>
                            : <JDText style={ st.show_time_wrap }>今日场次已放映完</JDText>
                        }
                    </View>
                }
                {(item.isFreqCinema == 1) && <JDImage style={ [st.cinema_been, { top: '0px' }] } source={ img.been } />}
                {(item.isFreqCinema == 1) &&
                    <ScrollView
                        contentContainerStyle={ st.offten_go_wrap }
                        showsHorizontalScrollIndicator={ false }
                        horizontal={ true }
                        style={ st.offten_wrap }
                    >
                        {item.moviePlanExts.map((offtenItem, offtenIndex) => {
                            return (
                                <TouchableOpacity
                                    activeOpacity={ 0.5 }
                                    style={ st.offten_go_item }
                                    key={ offtenIndex }
                                    onPress={ () => this.goBuy(item, offtenItem) }
                                >
                                    <JDText style={ st.offten_go_time }>{offtenItem.showTime}</JDText>
                                    <JDText numberOfLines={ 1 } style={ st.offten_go_type }>{offtenItem.playType}</JDText>
                                    <JDText style={ st.offten_go_price }>&yen;{offtenItem.price / 100}
                                        {offtenItem?.isPartitionPrice ? <JDText style = {st.offten_go_priceRise}>起</JDText>:""}
                                    </JDText>
                                    {item.nextState == 1 &&
                                        <View style={ st.offten_next_day_wrap }>
                                            <JDImage style={ st.offten_next_day } source={ img.nextDay } />
                                        </View>
                                    }
                                </TouchableOpacity>
                            );
                        })}
                    </ScrollView>
                }
            </TouchableOpacity>
        );
    }

    refresh() {
        this.setState({ wifiOut: false, loading: true ,cinemaList: []},()=>{
            // this.getMovieIssueShowDate();
            // this.getAllInfo();
            const {scheduledType} = this.props;
            if(+scheduledType===3){
                this.initCity();
            }else{
                this.getAllInfo()
            }
        });

         
    }

    toIndex = () => {
        this.context.router.toIndex();
    }

    _onScroll(e) {
        const info = e.nativeEvent;

        const height = info.contentSize.height;

        const scrollHeight = info.contentOffset.y;

        const screenHeight = info.layoutMeasurement.height;

        const { dateList, curDateIndex, pageNum, pageSize, queryDate, totalNum, toTopIsShow } = this.state;

        if (scrollHeight >= 10) {
            !toTopIsShow && this.setState({ toTopIsShow: true });
        } else {
            toTopIsShow && this.setState({ toTopIsShow: false });
        }
        const pageLoading = this.pageLoading;

        if (scrollHeight + screenHeight + 40 > height && pageNum <= totalNum && !pageLoading) {
            // tip(`正在加载第 ${pageNum} 页`);
            this.pageLoading = true;
            const date = dateList[curDateIndex].split(',')[1];

            this.getShowingCinemaList(date, pageNum, pageSize, queryDate);
        }
    }

    // 定位失败-选择城市
    goCity() {
        this.setState({
            dialog: false
        });
        this.context.router.toCity();
    }

    //  定位失败 点击取消  关闭弹层
    closeFalseDialog() {
        this.setState({
            dialog: false,
            // lbsDialog: false
        });
    }

    // 定位成功 点击‘取消’ 关闭弹层
    // closeDialog() {
    //     // let { cur_city } = this.props;

    //     // this._scroll.scrollTo({ x: 0, y: 0, animated: true });

    //     // this.getHomePageCinema(cur_city.cityId);

    //     this.setState({
    //         dialog: false,
    //         lbsDialog: false
    //     });
    // }

    // 切换到定位城市
    // setCity() {
    //     const { dispatch, lbsCity } = this.props;

    //     this._scroll.scrollTo({ x: 0, y: 0, animated: true });

    //     dispatch({
    //         type: 'cur_city',
    //         cur_city: lbsCity
    //     });

    //     storage.save({
    //         key: 'movieCityHistory',
    //         data: [lbsCity]
    //     });

    //     // this.getMovieIssueShowDate(lbsCity);
    //     this.getAllInfo(lbsCity);

    //     this.setState({
    //         dialog: false,
    //         cinemaList: [],
    //         lbsDialog: false
    //     });
    // }

    initCity() {
        this.getPosition().then(positionCityObj => {
            this.getSetCity(positionCityObj);
        }, () => {
            this.getSetCity();
        });
    }


    // 获取上一次访问的城市
    getSetCity(positionCityObj) {
        const { dispatch, cur_city } = this.props;

        // 与历史城市对比
        storage.load({
            key: 'movieCityHistory'
        }).then(hisres => {
            // 有历史记录
            if (hisres) {
                // 定位成功且有历史记录
                if (positionCityObj) {
                    const his_cityId = hisres[0].cityId;
                    //  如果定位城市和历史城市一致，直接展示定位城市
                    if (positionCityObj.cityId == his_cityId) {
                        dispatch({
                            type: 'cur_city',
                            cur_city: hisres[0]
                        });
                        // this.getMovieIssueShowDate(hisres[0]);
                        this.getAllInfo(hisres[0]);
                    } else { // 如果定位城市和历史城市不一致，展示历史城市，弹出切换城市弹层
                        dispatch({
                            type: 'cur_city',
                            cur_city: hisres[0]
                        });

                        // this.getMovieIssueShowDate(hisres[0]);
                        this.getAllInfo(hisres[0]);

                        // setTimeout(() => {
                        //     this.setState({ lbsDialog: true });
                        // }, 1000);
                    }
                } else { // 定位失败且有历史记录
                    dispatch({
                        type: 'cur_city',
                        cur_city: hisres[0]
                    });

                    // this.getMovieIssueShowDate(hisres[0]);
                    this.getAllInfo(hisres[0]);
                }
            } else { // 无历史记录
                if (positionCityObj) { // 定位成功且无历史记录，展示定位城市
                    dispatch({
                        type: 'cur_city',
                        cur_city: positionCityObj
                    });

                    // this.getMovieIssueShowDate(positionCityObj);
                    this.getAllInfo(positionCityObj);
                    // 保存定位城市到历史
                    storage.save({
                        key: 'movieCityHistory',
                        data: [positionCityObj]
                    });
                } else { // 定位失败且无历史记录，展示默认城市
                    // this.getMovieIssueShowDate(cur_city);
                    this.getAllInfo(cur_city);
                    this.setState({
                        dialog: true
                    });
                }
            }

            this.setState({
                recity: true
            });
        }).catch((err) => {
            console.log('err----',err)
            // 获取历史城市失败同无历史记录处理
            if (positionCityObj) {  // 定位成功且获取历史记录失败，展示定位城市
                dispatch({
                    type: 'cur_city',
                    cur_city: positionCityObj
                });
                // this.getMovieIssueShowDate(positionCityObj);
                this.getAllInfo(positionCityObj);
                // 保存定位城市到历史
                storage.save({
                    key: 'movieCityHistory',
                    data: [positionCityObj]
                });
                
            } else { // 定位失败且获取历史记录失败，展示默认城市
                // this.getMovieIssueShowDate(cur_city);
                this.getAllInfo(cur_city);
                // TODO/////////////
                // this.setState({dialog:true})
            }

            this.setState({
                recity: true
            });
        });
    }

    getPosition = async () => {
        const { dispatch } = this.props;
        
        try {
            const { lon, lat } = await getLBS(LBSbusinessId, sceneId);
            const res = await get('getCityInfoByLocation', { lon, lat, ip: 'l' }, true);

            dispatch({
                type: 'lbs',
                lbs: { lon, lat }
            });
            dispatch({
                type: 'lbsCity',
                lbsCity: res.data
            });

            return res.data;
        } catch (e) {
            this.setState({
                dialog: true
            });
            throw new Error('定位失败，可能是您的手机关闭了定位权限。您可以去手机设置-隐私-打开定位，或者手动选择城市。');
            // 定位失败：您未允许京东获取定位权限，您可在系统设置中开启
        }
        // const { isPosition } = this.state;
        // const { dispatch } = this.props;

        // console.log('isPosition------0000',isPosition);
        
        // if (isPosition) { return; };

        // // const handler = async() => {
        //     try {
        //         const { lon, lat } = await getLBS(LBSbusinessId, sceneId);

        //         dispatch({
        //             type: 'lbs',
        //             lbs: { lon, lat }
        //         });
        //         const res = await get('getCityInfoByLocation', { lon, lat, ip: 'l' }, true);
        //         const cityObj = res?.data;
        //         if (!cityObj) {
        //             this.setState({
        //                 dialog: true
        //             });
        //             this.setState({ 
        //                 positionSuccess: false, 
        //                 isPosition: false 
        //             });
        //             dispatch({
        //                 type: 'lbsCity',
        //                 lbsCity: cityObj
        //             });
        //             // tip('定位失败，可能是您的手机关闭了定位权限。您可以去手机设置-隐私-打开定位，或者手动选择城市。');
        //             throw new Error('定位失败，可能是您的手机关闭了定位权限。您可以去手机设置-隐私-打开定位，或者手动选择城市。');
        //         }
                

        //         this.setState({ 
        //             currentCity: cityObj.cityName, 
        //             positionSuccess: true, 
        //             isPosition: false 
        //         });
        //         // this.getFormattedPos(lat, lon).then(formattedAd => {
        //             // this.setState({ currentCity: cityObj.cityName, formattedAd, positionSuccess: true, isPosition: false });
        //         // }, () => {
        //         //     this.setState({ currentCity: cityObj.cityName, formattedAd: `${cityObj.cityName}市`, positionSuccess: true, isPosition: false });
        //         // });
        //         return cityObj

        //     } catch (e) {
        //         this.setState({ 
        //             positionSuccess: false, 
        //             isPosition: false
        //         });
        //         // tip('定位失败，可能是您的手机关闭了定位权限。您可以去手机设置-隐私-打开定位，或者手动选择城市。');
        //         throw new Error('定位失败，可能是您的手机关闭了定位权限。您可以去手机设置-隐私-打开定位，或者手动选择城市。');
        //     }
        // // };
        // // this.setState({ isPosition: true }, handler);
    }

    getFormattedPos(lat, lon) {
        return new Promise((resolve, reject) => {
            fetch(encodeURI(`https://apis.map.qq.com/ws/geocoder/v1/?location=${lat},${lon}&key=YSHBZ-MTHK5-BFMIG-QCLZ7-SSK72-6VF2G`), {
                method: 'GET'
                // headers: {
                //     referer: 'http://hotel.m.jd.com/index/kw'
                // }
            }).then(res => {
                return res.json();
            }).then(res => {
                if (res.status == 0) {
                    const addressInfo = res.result;

                    resolve(addressInfo.formatted_addresses.recommend);
                } else {
                    reject();
                }
            }).catch(e => {
                reject();
            });
        });
    }

    // checkoutCity() {
    //     const { dispatch, lbsCity } = this.props;

    //     dispatch({
    //         type: 'cur_city',
    //         cur_city: lbsCity
    //     });
    //     storage.save({
    //         key: 'movieCityHistory',
    //         data: [lbsCity]
    //     });
    //     this._scroll.scrollTo({ x: 0, y: 0, animated: false });
    //     this.setState({ wifiOut: false, loading: true, pageNum: 1, cinemaList: [], dateList: [], curDateIndex: 0 });
    //     this.setState({
    //         theRegionId: 0,
    //         theBrandId: 0,
    //         theDistanceId: 0,
    //         theDiscountId: '0',
    //         currentSearchType: null,
    //         currentRegion: {
    //             regionName: '全城',
    //             regionId: 0
    //         }, // 当前区域
    //         currentBrand: {
    //             brandName: '品牌',
    //             brandId: 0
    //         }, // 当前品牌
    //         currentDistance: {
    //             distanceName: '距离',
    //             distanceId: 0
    //         }
    //     }, () => {
    //         this.getMovieIssueShowDate();
    //     });
    // }

    showMore = () => {
        this.refMenu.setState({ isVisible: true });
    }

    _goTop() {
        this._scroll.scrollTo({ animated: true, x: 0, y: 0 });
    }

    setTitle = (title) => {
        document.title = title;
    }
}

MovieSchedule.contextTypes = {
    router: PropTypes.object
};

const select = (state) => {
    const { cur_city, lbs, lbsCity } = state.index;

    return { cur_city, lbs, lbsCity };
};

export default connect(select, null, null, { withRef: true })(MovieSchedule);